import {FuelsClassificationInputNames, MaterialType} from '@domain/materials'

import {ClassificationHeaderCells} from './ClassificationHeaderCells'

import {SHORT_COLUMN_WIDTH} from '@settings/modules/common/consts'

const fields = [
  {key: FuelsClassificationInputNames.FuelType},
  {key: FuelsClassificationInputNames.FuelCategory},
  {key: FuelsClassificationInputNames.FuelSubCategory},
  {key: FuelsClassificationInputNames.FormSize, minWidth: SHORT_COLUMN_WIDTH},
  {key: FuelsClassificationInputNames.ProcessingDegree}
]

export const FuelsClassificationHeader = () => {
  return <ClassificationHeaderCells fields={fields} materialType={MaterialType.Fuels} />
}
